import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/AltinSlider.css";
import AtaceyrekImage from "../assets/ata/ataceyrek.jpg";
import AtayarimImage from "../assets/ata/atayarim.jpg";
import AtaliraImage from "../assets/ata/atalira.jpg";
import Ata2Image from "../assets/ata/ata1.jpg";
import Ata5Image from "../assets/ata/ata5.png";
import CeyrekImage from "../assets/ziynet/ceyrek.jpg";
import YarimImage from "../assets/ziynet/yarım.jpg";
import ZiynetImage from "../assets/ziynet/ziynet.jpg";
import Ziynet2Image from "../assets/ziynet/ziynet2.jpg";
import Ziynet5Image from "../assets/ziynet/ziynet5.jpg";

const ataProducts = [
  {
    id: 1,
    name: "Ata Çeyrek",
    image: AtaceyrekImage,
    detail: {
      cins: "Ata Çeyrek",
      ağırlık: "1,804 Gram",
      ayar: "22 Ayar",
      çap: "14,75 mm",
      torba: "595 Adet",
      kulpsuzGram: "1,804 Gram",
    },
  },
  {
    id: 2,
    name: "Ata Yarım",
    image: AtayarimImage,
    detail: {
      cins: "Ata Yarım",
      ağırlık: "3,608 Gram",
      ayar: "22 Ayar",
      çap: "18 mm",
      torba: "298 Adet",
      kulpsuzGram: "3,608 Gram",
    },
  },
  {
    id: 3,
    name: "Ata Lira",
    image: AtaliraImage,
    detail: {
      cins: "Ata Lira",
      ağırlık: "7,216 Gram",
      ayar: "22 Ayar",
      çap: "22 mm",
      torba: "149 Adet",
      kulpsuzGram: "7,216 Gram",
    },
  },
  {
    id: 4,
    name: "Ata 2,5",
    image: Ata2Image,
    detail: {
      cins: "Ata İkibuçuklu",
      ağırlık: "18,04 Gram",
      ayar: "22 Ayar",
      çap: "30 mm",
      torba: "60 Adet",
      kulpsuzGram: "18,04 Gram",
    },
  },
  {
    id: 5,
    name: "Ata 5",
    image: Ata5Image,
    detail: {
      cins: "Ata Beşli",
      ağırlık: "36,08 Gram",
      ayar: "22 Ayar",
      çap: "35 mm",
      torba: "30 Adet",
      kulpsuzGram: "36,08 Gram",
    },
  },
];

const ziynetProducts = [
  {
    id: 1,
    name: "Çeyrek Altın",
    image: CeyrekImage,
    detail: {
      cins: "Ziynet Çeyrek",
      ağırlık: "1,754 Gram",
      ayar: "22 Ayar",
      çap: "18 mm",
      torba: "610 Adet",
      kulpsuzGram: "1,754 Gram",
    },
  },
  {
    id: 2,
    name: "Yarım Altın",
    image: YarimImage,
    detail: {
      cins: "Ziynet Yarım",
      ağırlık: "3,508 Gram",
      ayar: "22 Ayar",
      çap: "22 mm",
      torba: "305 Adet",
      kulpsuzGram: "3,508 Gram",
    },
  },
  {
    id: 3,
    name: "Ziynet Lira",
    image: ZiynetImage,
    detail: {
      cins: "Ziynet Lira",
      ağırlık: "7,016 Gram",
      ayar: "22 Ayar",
      çap: "30 mm",
      torba: "153 Adet",
      kulpsuzGram: "7,016 Gram",
    },
  },
  {
    id: 4,
    name: "Ziynet 2.5",
    image: Ziynet2Image,
    detail: {
      cins: "Ziynet İkibuçuklu",
      ağırlık: "17,540 Gram",
      ayar: "22 Ayar",
      çap: "40 mm",
      torba: "62 Adet",
      kulpsuzGram: "17,540 Gram",
    },
  },
  {
    id: 5,
    name: "Ziynet 5",
    image: Ziynet5Image,
    detail: {
      cins: "Ziynet Beşli",
      ağırlık: "35,08 Gram",
      ayar: "22 Ayar",
      çap: "45 mm",
      torba: "31 Adet",
      kulpsuzGram: "35,08 Gram",
    },
  },
];

const AltinSlider: React.FC = () => {
  const navigate = useNavigate();
  const [hoveredProduct, setHoveredProduct] = useState<{ type: 'ata' | 'ziynet', id: number } | null>(null);
  const [activeSlide, setActiveSlide] = useState<'ata' | 'ziynet'>('ata');
  const [isPaused, setIsPaused] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  // Otomatik slider effect
  useEffect(() => {
    if (!isPaused) {
      intervalRef.current = setInterval(() => {
        setActiveSlide((prev) => (prev === 'ata' ? 'ziynet' : 'ata'));
      }, 3000);
    }
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [isPaused]);

  // Mouse enter/leave eventleri
  const handleMouseEnter = () => setIsPaused(true);
  const handleMouseLeave = () => setIsPaused(false);

  return (
    <div className="altin-slider-container"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <header className="altin-slider-header-main">
        <h1>ZİYNET / ATA ALTIN GRUBU</h1>
        <p>Güvenilir yatırımın adresi, kaliteli altın çeşitleri</p>
      </header>

      <div className="altin-slider-controls">
        <button 
          className={`slider-button ${activeSlide === 'ata' ? 'active' : ''}`}
          onClick={() => setActiveSlide('ata')}
        >
          ATA ALTIN
        </button>
        <button 
          className={`slider-button ${activeSlide === 'ziynet' ? 'active' : ''}`}
          onClick={() => setActiveSlide('ziynet')}
        >
          ZİYNET ALTIN
        </button>
      </div>

      <div className="altin-slider-content">
        <div className={`slider-section ${activeSlide === 'ata' ? 'active' : ''}`}>
          <div className="altin-products">
            {ataProducts.map((product) => (
              <div
                key={product.id}
                className="product-card"
                onMouseEnter={() => setHoveredProduct({ type: 'ata', id: product.id })}
                onMouseLeave={() => setHoveredProduct(null)}
              >
                <img src={product.image} alt={product.name} className="product-image" />
                {hoveredProduct?.type === 'ata' && hoveredProduct?.id === product.id && (
                  <div className="product-detail">
                    <h3>{product.name}</h3>
                    <ul>
                      {Object.entries(product.detail).map(([key, value]) => (
                        <li key={key}>
                          <strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong> {value}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                <h2 className="product-name">{product.name}</h2>
              </div>
            ))}
          </div>
        </div>

        <div className={`slider-section ${activeSlide === 'ziynet' ? 'active' : ''}`}>
          <div className="altin-products">
            {ziynetProducts.map((product) => (
              <div
                key={product.id}
                className="product-card"
                onMouseEnter={() => setHoveredProduct({ type: 'ziynet', id: product.id })}
                onMouseLeave={() => setHoveredProduct(null)}
              >
                <img src={product.image} alt={product.name} className="product-image" />
                {hoveredProduct?.type === 'ziynet' && hoveredProduct?.id === product.id && (
                  <div className="product-detail">
                    <h3>{product.name}</h3>
                    <ul>
                      {Object.entries(product.detail).map(([key, value]) => (
                        <li key={key}>
                          <strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong> {value}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                <h2 className="product-name">{product.name}</h2>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AltinSlider; 